import script from "./BookingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingWidget.vue?vue&type=script&setup=true&lang=js"

import "./BookingWidget.vue?vue&type=style&index=0&id=1ca1be9f&lang=scss"

const __exports__ = script;

export default __exports__